import React from 'react';
import down from '../../images/trend-down.svg';
import even from '../../images/trend-even.svg';
import up from '../../images/trend-up.svg';
import { MeasurementHelper } from '../../lib/helpers/measurementHelper';

interface TrendIndicatorProps {
  helper: MeasurementHelper;
  trackerType: TrackerType;
}

const TrendIndicator: React.FC<TrendIndicatorProps> = ({ helper, trackerType }) => {
  let trendDirection: TrendDirection;

  if (trackerType === 'INTEGER') {
    trendDirection = helper.trend({
      aggregationType: 'sum',
      seriesType: 'sum'
    });
  } else {
    trendDirection = helper.trend({
      aggregationType: 'average',
      seriesType: 'average'
    });
  }

  if (trendDirection === 'Up') {
    return <img src={up} style={{ width: 10, height: 10 }} alt="Trending Up" />;
  }

  if (trendDirection === 'Down') {
    return <img src={down} style={{ width: 10, height: 10 }} alt="Trending Down" />;
  }

  return <img src={even} style={{ width: 10, height: 10 }} alt="Trending Even" />;
};

export default TrendIndicator;
